import orderMap from '@assets/images/OrderDetailMap.png';



export const Map = () => {

	return (
		<div className='detail-map'>
			<img src={orderMap} alt='order-detail-map' />
		</div>
	)
}

export default Map;